import React from "react";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col } from "react-bootstrap";

//Services
import Api from "../../services/api";

//Components
import ReportButtons from "../../Components/reports/ReportButtons";
import TableList from "../../Components/tableList/TableList";
import "../../Components/reports/reports.css";
import InputReport from "../../Components/inputReport/inputReport";
import "../../Components/inputReport/inputReport.css";
import DatePicker from "../../Components/datePicker/datePicker";
import MessageTable from "../../Components/messageTable/MessageTable";
import FilterBox from "../../Components/filterBox/filterBox";
import Select from "../../Components/select/select";

//Styles
import "../Prelude/prelude.css";
import styles from "../General/details.module.css";
import "./generalReports.css";
import "../../Components/filterBox/filterBox.css";

class ReportOEE extends React.Component {
  state = {
    text: "",
    resp: "",
    data: [],
    initialData: [],
    render: false,
    arrayWorkShifts: [],
    arr_idcodes: [],
    start_date: new Date().toLocaleDateString("pt-BR"),
    end_date: new Date().toLocaleDateString("pt-BR"),
    machine: "",
    item: "",
    loading: false,
    workshifts: [{ value: null, label: "Todos" }],
    workshift: null,
  };

  async componentDidMount() {
    this.getWorkShifts();
  }

  getWorkShifts = () => {
    Api.get("/work-shifts/").then((resp) => {
      if (resp.data.length > 0) {
        let wsPrev = this.state.workshifts;
        resp.data.forEach((element) => {
          wsPrev.push({ value: element.id, label: element.code });
        });
        this.setState({ workshifts: wsPrev });
      }
    });
  };

  selectWs = (data) => {
    this.setState({ workshift: data });
  };

  sendData = async () => {
    const params = {
      machine: this.state.machine.trim(),
      item: this.state.item.trim(),
      ws: this.state.workshift,
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date,
    };

    let count = 0;
    for (let p in params) {
      if (params[p]) count++;
    }
    if (count > 0) {
      this.setState({ loading: true });
      await Api.get("/reports/oee", { params: params })
        .then((resp) => {
          let arr = [];
          let aux = "";
          if (resp.data.length === 0) {
            this.setState({ render: false });
          } else {
            resp.data.forEach((elementReport) => {
              if (elementReport.Unidade === "m") {
                aux = elementReport.produced + "m";
              } else if (elementReport.Unidade === "pcs") {
                aux = elementReport.produced + "pcs";
              } else if (elementReport.Unidade === "m2") {
                aux = elementReport.produced + "m2";
              } else if (elementReport.Unidade === "kg") {
                aux = elementReport.produced + "kg";
              } else {
                aux = elementReport.produced;
              }

              arr.push({
                ["Seq."]: elementReport["Seq"],
                Máquina: elementReport["Máquina"],
                Ordem: elementReport.Ordem,
                Item: elementReport.Item,
                Operador: elementReport.Operador,
                Data: moment(elementReport.Data).format("DD/MM/YYYY"),
                ["Data final"]: moment(elementReport["Data final"]).format(
                  "DD/MM/YYYY"
                ),
                Início: elementReport.Inicio,
                Fim: elementReport.Fim,
                Tempo: elementReport.Tempo,
                ["Previsto"]: elementReport.planned_time,
                ["Parado"]: elementReport.loss_time,
                Produzido: elementReport.produced == 0 ? 0 : aux,
                Refugo:
                  elementReport.refuse_amount == 0
                    ? 0
                    : `${elementReport.refuse_amount}${elementReport.Unidade}`,
                FTQ: elementReport.ftq,
                OEE: elementReport["OEE"] + "%",
                ["Disponibilidade"]: elementReport["Disponibilidade"] + "%",
                ["Performance"]: elementReport["Performance"] + "%",
                ["Qualidade"]: elementReport["Qualidade"] + "%",
                Turno: elementReport.shift,
              });
            });
            this.setState({ data: arr, render: true, initialData: arr });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          alert("Erro de conexão com o servidor");
        });

      await Api.get("/work-shifts/")
        .then((resp) => {
          let arr_codes = [];
          let arr_ids = [];
          resp.data.forEach((elementReport) => {
            arr_codes.push({ value: elementReport.code });
            arr_ids.push({ id: elementReport.id, code: elementReport.code });
          });
          this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids });
          if (this.state.loading) this.setState({ loading: false });
        })
        .catch((error) => {
          if (error.response) {
            return alert(
              error.response.data +
                "\n" +
                error.response.status +
                "\n" +
                error.response.headers
            );
          }
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  };

  excelbutton = (event) => {
    if (this.state.data.length === 0) {
      alert("Preencha um campo de filtro");
      event.preventDefault();
    }
  };

  saveText = (data) => {
    const { value, name } = data;
    this.setState({ [`${name}`]: value });
  };

  filterData = (data, name) => {
    this.setState({ [`${name}`]: data });
  };

  render() {
    return (
      <>
        <FilterBox title="Filtros" spacePadding>
          <Row type="input" className="w-100">
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <InputReport
                name="machine"
                parentCallback={this.saveText}
                title="Máquina"
                focus={true}
              />
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <InputReport
                name="item"
                parentCallback={this.saveText}
                title="Item"
              />{" "}
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <DatePicker
                name="Data"
                title="Data Inicial"
                parentCallback={(e) => this.filterData(e, "start_date")}
              ></DatePicker>
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <DatePicker
                name="Data"
                title="Data Final"
                parentCallback={(e) => this.filterData(e, "end_date")}
              ></DatePicker>
            </Col>
            <Col
              lg={4}
              sm={12}
              xs={12}
              type="input"
              className="p-1 mb-1 selectFilter"
              id="filterSelect"
            >
              <Select
                label="Turno"
                arrData={this.state.workshifts}
                handleSelect={(e) => {
                  this.selectWs(e);
                }}
              />
            </Col>
          </Row>
          <ReportButtons
            type="input"
            handleClick={this.sendData}
            excelData={this.state.data}
            surnameFile="oee"
          />
        </FilterBox>
        <div className="filters boxReport">
          {this.state.loading ? (
            <div className="TableReport">
              <div style={{ marginTop: "20vh" }} className={styles.loader}>
                <Spinner variant="success" animation="border" />
                <strong>Carregando...</strong>
              </div>
            </div>
          ) : (
            <div className="TableReport">
              {this.state.render ? (
                <TableList data={this.state.data}></TableList>
              ) : (
                <div>
                  <MessageTable message={"Sem dados para processar."} />
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default ReportOEE;
